import { render, staticRenderFns } from "./interest-rates.page.vue?vue&type=template&id=17a18a80&"
import script from "./interest-rates.page.vue?vue&type=script&lang=ts&"
export * from "./interest-rates.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports